import request from 'request-promise';

import thunker from './thunker';
import { API_URL } from './urls';

// Get available actions by expiring token
export const GET_ACTIONS = "GET_ACTIONS";
export const GET_ACTIONS_FAILURE = "GET_ACTIONS_FAILURE";
export const GET_ACTIONS_SUCCESS = "GET_ACTIONS_SUCCESS";


export const getActionsByToken = token => (
  thunker({
    types: [
      GET_ACTIONS,
      GET_ACTIONS_SUCCESS,
      GET_ACTIONS_FAILURE,
    ],
    promise: getActions(token),
    data: { token },
  })
);

const getActions = async (token) => {
  const options = {
    method: 'GET',
    uri: `${API_URL}/getUserActions/${token}`,
    json: true,
  };

  return request(options);
};

export const submitActionReport = (report, token) => (
  async () => {
    const options = {
      method: 'POST',
      uri: `${API_URL}/saveActionReport/${token}`,
      body: {
        payload: {
          data: report,
        },
      },
      json: true,
    };

    return request(options);
  }
)



// WEBPACK FOOTER //
// ./src/actions/reportActions.js